exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "th:hover {\n    cursor: pointer;\n    cursor: hand;\n}\n.sortable {\n    color: red;\n}\n\nbody {\n    background-color: red;\n}\ntd h4 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\ntd a {\n    font-weight: bold;\n}\n.label-2review {\n        background-color: #86608c;\n}\n.label-escalated {\n    background-color: #d67017;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/grants-list/grants-list.component.css
// module id = 857
// module chunks = 1